<ng-container *ngIf="enabled">
  <div class="toolbar-sticky border-bottom bg-light sticky-top mb-2 d-print-m-0" id="toolbar-sticky" *transloco="let t; read: 'ime.components.action-bar'">
    <ol class="breadcrumb" *ngIf="breadCrumbs?.length">
      <li *ngFor="let breadcrumb of breadCrumbs; last as isLast"
          class="breadcrumb-item">
        <a *ngIf="!isLast" [routerLink]="getRouteParams(breadcrumb)">{{ breadcrumb.label }}</a>
        <span class="text-primary" *ngIf="isLast">{{ breadcrumb.label }}</span>
      </li>
      <router-outlet name='breadcrumb'></router-outlet>
    </ol>
    <div class="col-4 me-auto d-flex" *ngIf="actionBarService.searchOptions.enabled">
      <div class="input-group input-group-sm my-auto d-print-none">
        <input name="globalSearch" autocomplete="off" class="form-control" type="search" placeholder="{{t('Search')}}" [(ngModel)]="searchString" (ngModelChange)='searchChanged($event)'
               [ngControlOptions]="{ updateOn: 'input', debounce: { 'input': 200 } }">
        <button class="btn btn-outline-primary" *ngIf="actionBarService.searchOptions.advanced" type="button" (click)="toggleAdvanced()" [ngClass]="{'active': actionBarService.advancedFilter$ | async}">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-double-down"></svg>
        </button>
      </div>
      <help-button *transloco="let h" [key]="h('help.ime.general.search')"></help-button>
    </div>
    <router-outlet name='action-bar'></router-outlet>
  </div>
</ng-container>

